import { z } from 'zod';
/**
 * Saved-search contract (Phase 14 — donor feed).
 *
 * The platform already persists notification filters in the `user_filters`
 * collection (untyped `{user_id, filters, is_active}`). Phase 14 adds a `type`
 * discriminator so a filter can be a DONOR saved search: a standing interest in
 * write-off / heavy-damage lots (donor cars for parts). A donor lot is one whose
 * Deal Score damage-risk component is at/below {@link DONOR_MAX_DAMAGE_RISK}
 * (i.e. DamageSeverity severe→0.25 or total_loss→0 in DEAL_SCORE_DAMAGE_RISK).
 */
export const SavedSearchTypeSchema = z.enum(['standard', 'donor']);
/**
 * Donor threshold on `ai_car_analysis.deal_score.components.damageRisk`. Lots
 * with `damageRisk <= DONOR_MAX_DAMAGE_RISK` are donor candidates (severe or
 * total-loss). Mirrors DEAL_SCORE_DAMAGE_RISK: SEVERE = 0.25, TOTAL_LOSS = 0.
 */
export const DONOR_MAX_DAMAGE_RISK = 0.25;
/**
 * Saved-search view (superset of the legacy `user_filters` doc). `type` defaults
 * to 'standard' so every pre-Phase-14 filter is a standard saved search.
 */
export const SavedSearchSchema = z.object({
    _id: z.unknown().nullish(),
    /** Legacy field name in `user_filters` is `user_id`; kept for compatibility. */
    user_id: z.string(),
    type: SavedSearchTypeSchema.default('standard'),
    filters: z.record(z.unknown()).default({}),
    is_active: z.boolean().default(true),
    createdAt: z.coerce.date().nullish(),
});
//# sourceMappingURL=saved-search.js.map